import React from 'react'
import clsx from 'clsx'

interface PillButtonElementProps {
  className?: any
  text: any
  value?: string | number
  onButtonClicked?: any
  selected?: boolean
  visible?: boolean
  disabled?: boolean
}

const PillButtonElement: React.FC<PillButtonElementProps> = (props) => {
  const visible = props?.visible ?? true

  return (
    <button
      type="button"
      disabled={props?.disabled ?? false}
      onClick={(_) => props?.onButtonClicked?.(props.value, !props.selected)}
      className={clsx(
        props.selected
          ? 'bg-SeabiscuitMainThemeColor/5 text-SeabiscuitMainThemeColor border-[#F7076300]'
          : 'bg-white border-SeabiscuitGrayThemeColor disabled:hover:!text-SeabiscuitDark200ThemeColor',
        'px-2 text-center py-2 relative rounded-[12px] 2xl:min-w-[110px] xl:min-w-[100px] text-SeabiscuitDark200ThemeColor transition ease-in duration-200 text-[15px] focus:outline-none border border-solid hover:text-SeabiscuitMainThemeColor !ml-0 !mr-[5px]',
        visible ? 'block' : 'hidden',
        props.className
      )}
    >
      {props.text}
    </button>
  )
}

export { PillButtonElement }
